export const CLASSIC_BASE = 'automation';
export const HYBRID_PERFORMANCE_LIST_COUNTS = `${CLASSIC_BASE}/v3/performance/workflow`;